<!-- OrganizationID -->

<div class="support-tool">
    <div class="support-tool-title">Generic Report</div>
    <div class="support-tool-content">
        <div class="support-tool-input-box">
            <span class="support-tool-input-label">OrganizationID</span>
            <input type="number" class="support-tool-input" [(ngModel)]="organizationID">
        </div>

        <button *ngIf="!running" class="btn btn-primary support-tool-button" (click)="getResult()">Run</button>
        
        <app-loading-spinner *ngIf="running"></app-loading-spinner>
    </div>
</div>